import { render } from "./project.vue?vue&type=template&id=97d2040a&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"

import "./project.vue?vue&type=style&index=0&id=97d2040a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-97d2040a"

export default script